import { QueryClientProvider, type QueryClientProviderProps } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "@/lib/providers/query";

export function QueryProvider(
  props: React.PropsWithChildren<Omit<QueryClientProviderProps, "client">>,
) {
  return (
    <QueryClientProvider client={queryClient} {...props}>
      {props.children}
      {import.meta.env.NODE_ENV !== "production" && <ReactQueryDevtools />}
    </QueryClientProvider>
  );
}
